import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { WorkTab } from "types/ui/card-item";
import PageLayout from "components/layout/page-layout";
import { useSharedState } from "state";

interface TabsLayoutProps {
  tabs: WorkTab[];
  header: string;
  subheaderText?: string;
  buttonText: string;
}

export default function TabsLayout({ tabs, header, subheaderText, buttonText }: TabsLayoutProps) {
  const { currentPageTab, setCurrentPageTab } = useSharedState();
  const [searchParams] = useSearchParams();
  const taskType = searchParams.get("type");

  const navigate = useNavigate();

  const content = (
    <>
      <ul className="nav nav-bordered mb-4">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab.id}>
            <div
              className={`nav-link cursor-pointer ${currentPageTab === tab.id ? "active" : ""}`}
              onClick={() => setCurrentPageTab(tab.id)}
            >
              {tab.title}
            </div>
          </li>
        ))}
      </ul>
      {tabs.find((tab) => tab.id === currentPageTab)?.component}
    </>
  );

  return (
    <>
      <PageLayout
        children={content}
        header={header}
        subheaderText={subheaderText}
        search={true}
        filters={true}
        buttonText={buttonText}
        buttonAction={() => navigate(taskType === "other" ? "create?type=other" : "create")}
      />
      <Outlet />
    </>
  );
}
